<app-main
    [mission]="defualtStrategy?.mission || ''"
    [vision]="defualtStrategy?.vision || ''">
</app-main>